import CopyrightIcon from '@mui/icons-material/Copyright'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import {useAppNavigate} from 'app/hooks/navigation/useAppNavigate'
import AppBar from './header/AppBar'

function Hypersonic() {
  const navigate = useAppNavigate()
  const handleRegisterRoute = (type: string) => {
    navigate(`/register?type=hci`)
  }
  return (
    <Box sx={{backgroundColor: '#f5f8fa'}}>
      <AppBar />
      <Box
        maxWidth={'1320px'}
        margin={'auto'}
        display={'flex'}
        flexDirection={'column'}
        height={'100vh'}
      >
        <Box
          pt={5}
          display={'flex'}
          className='container'
          flexDirection={'column'}
          flexWrap={'wrap'}
          gap={5}
        >
          {/* title */}
          <Box display={'flex'} justifyContent={'center'} mt={2}>
            <Typography variant={'h2'} sx={{fontWeight: 700}}>
              HYPERSONIC CLUSTERING INITIATIVE
            </Typography>
          </Box>

          <Box display={'flex'} gap={2} flexDirection={'column'}>
            <Box>
              <Typography variant={'h5'} fontWeight={700} mb={1}>
                HCI
              </Typography>
              <Typography variant={'body1'} fontSize={'1.25em'}>
                U.S. peers and adversaries are rapidly advancing hypersonic technologies and weapons
                systems. To remain competitive in this critical area of technology, the U.S. needs
                to enlist and activate all of its defense, commercial and academic institutions. The
                hypersonic clustering initiative (“HCI”) is a strategy to coordinate the activities
                of research scientists, faculty, facilities and industry with expertise in
                hypersonic fields to accelerate hypersonic R&D and commercialization by increasing
                collaboration and expanding access to R&D funding, facilities and expertise.
              </Typography>
            </Box>
          </Box>
          <Box mb={1}>
            <Typography variant={'h5'} fontWeight={700} mb={1}>
              Objective:
            </Typography>
            <Typography variant={'body1'} fontSize={'1.25em'}>
              The purpose of the HCI is to enhance national defense and commercial interests by
              helping the SSP (Strategic Systems Programs), CPS Program (Conventional Prompt
              Strike), the JHTO Field Activity (Joint Hypersonics Transition Office Field Activity),
              and other defense organizations engage teams from industry and academia to accelerate
              the development and deployment of innovative solutions to hypersonic challenges of
              interest to DoD.
            </Typography>
          </Box>
          <Box mb={5}>
            <Typography variant={'h5'} fontWeight={700} mb={1}>
              Events:
            </Typography>
            <Typography variant={'body1'} fontSize={'1.25em'}>
              The HCI will be hosting several events during the summer and fall of 2023 to bring the
              DoD, industry and academia together to develop innovative solutions to DoD hypersonic
              challenges. We will host a Hypersonic Hackathon in October at NSWC Crane with the
              intent of teeing up proposals addressing hypersonic topics for the 24.1 and 24.2
              SBIR|STTR solicitation cycles.
            </Typography>
            <Typography variant={'body1'} fontSize={'1.25em'} mt={1}>
              We are seeking innovative small businesses, faculty, government personnel, systems
              integrators, consultants and other support organizations to advance the cause of
              developing hypersonic innovation. To get more information or join the effort, please
              sign up.
            </Typography>
            <br />
            <Button
              color={'info'}
              onClick={() => handleRegisterRoute('hci')}
              variant={'contained'}
              sx={{fontWeight: 700, fontSize: '1.25rem'}}
            >
              HCI Registration form
            </Button>
          </Box>
        </Box>
      </Box>
      <Box
        style={{
          height: '50px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#181c32',
          color: 'white',
          marginBottom: 0,
          bottom: 0,
        }}
      >
        <CopyrightIcon sx={{mr: 1}} />
        2023
      </Box>
    </Box>
  )
}

export {Hypersonic}
